import { createSelector } from '@ngrx/store';
import { selectShipmentLocationsState } from '../reducers';
import * as fromCxShipmentLocation from '../reducers/cx-shipment-location.reducer';
import { CxShipmentLocation } from '../../models/shipment-location';

export const selectCxShipmentLocations = createSelector(selectShipmentLocationsState, fromCxShipmentLocation.selectAll);
export const selectCxShipmentLocationIds = createSelector(
  selectShipmentLocationsState,
  fromCxShipmentLocation.selectIds,
);
export const selectCxShipmentLocationEntities = createSelector(
  selectShipmentLocationsState,
  fromCxShipmentLocation.selectEntities,
);
export const selectCxShipmentLocationTotal = createSelector(
  selectShipmentLocationsState,
  fromCxShipmentLocation.selectTotal,
);
export const selectCxShipmentLocationById = createSelector(
  selectCxShipmentLocationEntities,
  (cxShipmentLocationEntities, { id }) => cxShipmentLocationEntities[id],
);
export const selectCxShipmentLocationsById = () =>
  createSelector(
    selectCxShipmentLocationEntities,
    (cxShipmentLocationEntities, { ids }) =>
      ids.map((id) => cxShipmentLocationEntities[id]).filter(Boolean) as CxShipmentLocation[],
  );
export const selectActiveCxShipmentLocationId = () =>
  createSelector(selectShipmentLocationsState, fromCxShipmentLocation.selectActiveEntityId);

export const selectActiveCxShipmentLocation = createSelector(
  selectCxShipmentLocationEntities,
  selectActiveCxShipmentLocationId(),
  (cxShipmentLocationEntities, id) => id && cxShipmentLocationEntities[id],
);
